/**
 * Monitor app release milestones (calendar date, inclusive from).
 * Same-day releases keep the latest listed version for that day.
 */
export const MONITOR_APP_VERSION_RELEASES = [
  { from: '2025-10-07', version: '1.0.0' },
  { from: '2025-10-27', version: '0.1.x' },
  { from: '2026-07-27', version: '1.0.0' },
  { from: '2026-07-29', version: '1.1.0' },
  { from: '2026-08-05', version: '1.2.0' },
  { from: '2026-09-17', version: '1.2.2' },
  { from: '2026-10-22', version: '1.2.4' },
] as const;

const toIsoDateUtc = (value: Date): string | null => {
  if (Number.isNaN(value.getTime())) {
    return null;
  }

  const year = value.getUTCFullYear();
  const month = String(value.getUTCMonth() + 1).padStart(2, '0');
  const day = String(value.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const resolveMonitorAppVersionForDate = (
  value: string | Date | null | undefined
): string => {
  if (value == null || value === '') {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);
  const isoDay = toIsoDateUtc(date);
  if (!isoDay) {
    return '';
  }

  let version = '';
  for (const release of MONITOR_APP_VERSION_RELEASES) {
    if (isoDay >= release.from) {
      version = release.version;
    }
  }

  return version;
};
